import { AmenityType } from '@commonTuna/react/objects/Amenity';

import acceptsInsurance from '@commonTuna/react/images/amenities/accept.png';
import acceptsCreditCards from '@commonTuna/react/images/amenities/credit-card-payment.png';
import acceptsApplePay from '@commonTuna/react/images/amenities/apple-pay.png';
import acceptsAndroidPay from '@commonTuna/react/images/amenities/android-pay.png';
import acceptsCryptocurrency from '@commonTuna/react/images/amenities/cryptocurrencies.png';
import freeWiFi from '@commonTuna/react/images/amenities/free-wifi.png';
import paidWiFi from '@commonTuna/react/images/amenities/connection.png';
import streetParking from '@commonTuna/react/images/amenities/road.png';
import privateLotParking from '@commonTuna/react/images/amenities/parking.png';
import garageParking from '@commonTuna/react/images/amenities/garage.png';
import bikeParking from '@commonTuna/react/images/amenities/bicycle.png';
import offersMilitaryDiscount from '@commonTuna/react/images/amenities/discount.png';
import goodForKids from '@commonTuna/react/images/amenities/safe-for-children.png';
import wheelchairAccessible from '@commonTuna/react/images/amenities/accessibility.png';
import quiet from '@commonTuna/react/images/amenities/keep-quiet.png';
import openToAll from '@commonTuna/react/images/amenities/open-sign.png';
import byAppointmentOnly from '@commonTuna/react/images/amenities/appointments.png';

export const AmenityTypeIcons = {
	[AmenityType.AcceptsInsurance]: acceptsInsurance,
	[AmenityType.AcceptsCreditCards]: acceptsCreditCards,
	[AmenityType.AcceptsApplePay]: acceptsApplePay,
	[AmenityType.AcceptsAndroidPay]: acceptsAndroidPay,
	[AmenityType.AcceptsCryptocurrency]: acceptsCryptocurrency,
	[AmenityType.FreeWiFi]: freeWiFi,
	[AmenityType.PaidWiFi]: paidWiFi,
	[AmenityType.StreetParking]: streetParking,
	[AmenityType.PrivateLotParking]: privateLotParking,
	[AmenityType.GarageParking]: garageParking,
	[AmenityType.BikeParking]: bikeParking,
	[AmenityType.OffersMilitaryDiscount]: offersMilitaryDiscount,
	[AmenityType.GoodForKids]: goodForKids,
	[AmenityType.WheelchairAccessible]: wheelchairAccessible,
	[AmenityType.Quiet]: quiet,
	[AmenityType.OpenToAll]: openToAll,
	[AmenityType.ByAppointmentOnly]: byAppointmentOnly,
};
